import React, { useEffect, useState } from 'react';
import { Card } from '@uhg-abyss/web/ui/Card';
import { Grid } from '@uhg-abyss/web/ui/Grid';

import { V1Table as Table } from '@uhg-abyss/web/ui/Table';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { RadioGroup } from '@uhg-abyss/web/ui/RadioGroup';
import { FormProvider } from '@uhg-abyss/web/ui/FormProvider';
import { useForm } from '@uhg-abyss/web/hooks/useForm';
import { Button } from '@uhg-abyss/web/ui/Button';

import { SelectInput } from '@uhg-abyss/web/ui/SelectInput';
import { CheckboxGroup } from '@uhg-abyss/web/ui/CheckboxGroup';
import { Checkbox } from '@uhg-abyss/web/ui/Checkbox';

import {
  useLazyGetInternalUserAclQuery,
  useLazyRemoveInternalUserAclQuery,
  useLazyUpdateInternalUserAclQuery,
} from '@src/store/services/LoginServices';
import { TextInput } from '@uhg-abyss/web/ui/TextInput';
import { Box } from '@uhg-abyss/web/ui/Box';
import { useAuth } from '@src/Providers/AuthProvider';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Divider } from '@uhg-abyss/web/ui/Divider';
import { footerDateformat, formtDate } from '@src/utils';
import { useToast } from '@uhg-abyss/web/hooks/useToast';

interface DataType {
  userId?: string;
  userStsCd?: string;
  locTyp?: string;
  maskTyp?: string;
  secureData?: any;
  srcTyp?: string[];
  updtTime?: string;
  updtUser?: string;
}

const RoleAdmin = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [isSearchButtonClicked, setIsSearchButtonClicked] = useState(false);

  const [gettingUserIdDetails] = useLazyGetInternalUserAclQuery();
  const [upDateUserDetails] = useLazyUpdateInternalUserAclQuery();
  const [removeUserDetails] = useLazyRemoveInternalUserAclQuery();
  const [data, setData] = useState<DataType>({});

  const [isEditable, setIsEditable] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successData, setSuccessData] = useState('');
  const [isSubmitclicked, setIsSubmitclicked] = useState(false);
  const [errors, setErrors] = useState([]);

  const { user } = useAuth();
  const { toast } = useToast();

  const resetSearchResult = () => {
    setData({});
    setIsSearchButtonClicked(false);
    setIsEditable(false);
  };

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(event.target.value);
    resetSearchResult();
  };

  const cardCssStyles = {
    'abyss-card-root': {
      maxWidth: '80%',
      margin: '10px auto',
    },
  };

  const handleSearchClick = async () => {
    const regex = /^[a-z0-9]*$/; // Regex to allow only lowercase alphabets and digits
    if (regex.test(searchTerm)) {
      setSearchTerm(searchTerm);
      const { data: responseData } = await gettingUserIdDetails(searchTerm);
      const hasData =
        responseData &&
        typeof responseData === 'object' &&
        Object.keys(responseData).length > 0;

      setData(hasData ? responseData : {});
      setIsEditable(!!hasData);
      setIsSearchButtonClicked(!!hasData);
    } else {
      toast.show({
        title: 'Invalid UsrerId',
        message: 'Please enter only lowercase letters and digits !',
      });
    }
    setSuccessData('');
  };

  const form = useForm({
    defaultValues: {
      ...data,
      locTyp: String(data?.locTyp),
      maskTyp: String(data?.maskTyp),
      secureData: data?.secureData,
      srcTyp: Array.isArray(data?.srcTyp) ? data.srcTyp.map(String) : [],
    },
  });
  useEffect(() => {
    if (data && Object.keys(data).length)
      form.reset({
        ...data,
        locTyp: String(data?.locTyp),
        maskTyp: String(data?.maskTyp),
        secureData: data?.secureData,
        srcTyp: Array.isArray(data?.srcTyp) ? data.srcTyp.map(String) : [],
      });
  }, [data]);
  const handleReset = () => {
    setIsEditable(true);
    form.reset({
      ...data,
      locTyp: String(data?.locTyp),
      maskTyp: String(data?.maskTyp),
      secureData: data?.secureData,
      srcTyp: Array.isArray(data?.srcTyp) ? data?.srcTyp.map(String) : [],
    });
  };

  const handleSubmit = async () => {
    const adminDetails = form.getValues();
    const {
      userId,
      userRole,
      srcTyp,
      maskTyp,
      secureData,
      locTyp,
      comnt,
      userStsCd,
    } = adminDetails;

    const payload = {
      userId: userId || searchTerm,
      userRole: userRole,
      srcTyp: Array.isArray(srcTyp) ? srcTyp : [srcTyp],
      maskTyp: maskTyp,
      secureData: secureData ?? false,
      locTyp: locTyp,
      comnt: comnt,
      updtUser: user?.userId,
      userStsCd: 'A',
      updtTime: '',
    };

    const isEmpty = Array.isArray(srcTyp) && srcTyp?.length === 0;
    const validate = () => {
      const newErrors: string[] = [];

      if (
        userRole === '' ||
        userRole === null ||
        userRole === undefined ||
        userRole === 0
      ) {
        newErrors.push(
          'User Role Is a Required Field. Please Select Role Type'
        );
      }

      if (srcTyp === '' || isEmpty) {
        newErrors.push('Please Select  Atleaset one Source Type');
      }

      setErrors(newErrors);
      return newErrors?.length === 0;
    };

    if (validate()) {
      const response = await upDateUserDetails({ ...payload });
      if (response?.isSuccess) {
        setData(response?.data);
        setIsEditable(true);
        setSuccessData(response?.isSuccess);
        setIsSubmitclicked(true);
        toast.show({
          title: `${userId || searchTerm} Access is Updated`,
          message: 'Submitted Successfully',
          type: 'success',
        });
      } else {
        toast.show({
          title: 'Error Occured',
          message: 'Something is Wrong Please Try Later !',
        });
      }
    }
  };
  const handleUserremoval = async () => {
    const payload = {
      userId: form.watch('userId'),
      updtUser: user?.userId,
      userStsCd: 'D',
    };
    alert(`Are you sure you Want to remove ${form.watch('userId')} `);
    const response = await removeUserDetails(payload);
    if (response?.isSuccess) {
      form.reset({
        userId: form.watch('userId'),
        userRole: null,
        locTyp: null,
        maskTyp: null,
        secureData: null,
        srcTyp: [],
        comnt: '',
      });
      toast.show({
        title: ``,
        message: response.data,
        type: 'success',
        autoClose: 3000,
      });
      setSuccessData(response?.data);
    }
  };

  return (
    <FormProvider state={form}>
      <Grid>
        <Grid.Col
          css={{
            width: '100%',
            height: '50vh',
          }}
        >
          <Card css={cardCssStyles}>
            <div
              style={{
                backgroundColor:
                  'var(--abyss-colors-web-semantic-color-surface-container-primary)',
                color:
                  'var(--abyss-colors-web-semantic-color-text-content-primaryAlt)',
                paddingTop: '5px',
                paddingBottom: '5px',
                paddingLeft: '24px',
                paddingRight: '24px',
                borderTopLeftRadius: '3px',
                borderTopRightRadius: '3px',
                fontSize: '18px',
                fontWeight: 'bold',
              }}
            >
              Role Administration
            </div>
            <Layout.Stack
              css={{ gap: '20px', width: '100%', minHeight: '80vh' }}
              grow
            >
              <Layout.Group space={10} css={{ marginLeft: '90px' }}>
                <span>
                  <strong>Search For:</strong>
                </span>
                <TextInput
                  label=""
                  placeholder=""
                  value={searchTerm}
                  maxLength={10}
                  isClearable
                  onClear={() => {
                    setSearchTerm('');
                    resetSearchResult();
                  }}
                  onChange={(e) => handleSearchChange(e)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter' && searchTerm) {
                      event.preventDefault();
                      handleSearchClick();
                    }
                  }}
                />
                <Button
                  size="$md"
                  onClick={handleSearchClick}
                  isDisabled={!searchTerm}
                >
                  Find
                </Button>
              </Layout.Group>
              {errorMessage && (
                <Box
                  align="center"
                  color="transparent"
                  padding={0}
                  css={{ 'abyss-box-root': { color: 'red' } }}
                >
                  {errorMessage}
                </Box>
              )}
              {errors?.length > 0 && (
                <Box
                  align="center"
                  color="transparent"
                  padding={0}
                  css={{ 'abyss-box-root': { color: 'red' } }}
                >
                  <ul>
                    {errors.map((error, index) => (
                      <li key={index}>{error}</li>
                    ))}
                  </ul>
                </Box>
              )}
              {successData && (
                <Box
                  align="center"
                  color="transparent"
                  padding={0}
                  css={{ 'abyss-box-root': { color: 'green' } }}
                >
                  {successData}
                </Box>
              )}
              <Layout.Group alignLayout="center">
                {isSearchButtonClicked && (
                  <Table.Container title="">
                    <Table.Row>
                      <Table.Cell css={{ width: '450px' }}>
                        <strong>User ID</strong>
                      </Table.Cell>
                      <Table.Cell>{data?.userId || searchTerm}</Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        <strong>Role</strong>
                      </Table.Cell>
                      <Table.Cell>
                        <SelectInput
                          label=""
                          placeholder="select option"
                          model="userRole"
                          isClearable
                          isSearchable
                          options={[
                            {
                              label: 'Electronic Eligibility Operations',
                              value: 2,
                            },
                            { label: 'EEMS Production Support', value: 4 },
                            {
                              label: 'Client/Customer Services  ',
                              value: 8,
                            },
                            { label: 'EEMS Administrator  	 ', value: 1 },
                          ]}
                          isDisabled={isEditable}
                        />
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <strong>Source</strong>
                      </Table.Cell>
                      <Table.Cell>
                        <CheckboxGroup
                          isDisabled={isEditable}
                          label=""
                          model="srcTyp"
                        >
                          <CheckboxGroup.Column>
                            <Checkbox label="Commercial" value="4" />
                            <Checkbox label="M & R" value="2" />
                            <Checkbox label="Prime" value="8" />
                            <Checkbox label="Optum" value="16" />
                            <Checkbox label="Medicaid" value="32" />
                            <Checkbox label="Medicare" value="64" />
                          </CheckboxGroup.Column>
                        </CheckboxGroup>
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <strong>Masking</strong>
                      </Table.Cell>
                      <Table.Cell>
                        <RadioGroup
                          isDisabled={isEditable}
                          label=""
                          model="maskTyp"
                        >
                          <RadioGroup.Column>
                            <RadioGroup.Radio label="No Mask" value="0" />

                            <RadioGroup.Radio label="Sal Mask" value="1" />
                            <RadioGroup.Radio label="SSN Sal Mask" value="3" />
                          </RadioGroup.Column>
                        </RadioGroup>
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        <strong>Secured Data</strong>
                      </Table.Cell>
                      <Table.Cell>
                        <Checkbox
                          isDisabled={isEditable}
                          label="UHG Data"
                          model="secureData"
                        />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>
                        <strong>Location</strong>
                      </Table.Cell>
                      <Table.Cell>
                        <RadioGroup
                          isDisabled={isEditable}
                          label=""
                          model="locTyp"
                        >
                          <RadioGroup.Column>
                            <RadioGroup.Radio label="On Shore" value="1" />
                            <RadioGroup.Radio label="Off Shore" value="2" />
                          </RadioGroup.Column>
                        </RadioGroup>
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>
                        <strong>Comments</strong>
                      </Table.Cell>
                      <Table.Cell>
                        <TextInput
                          isDisabled={isEditable}
                          label=""
                          placeholder=""
                          model="comnt"
                          maxLength={50}
                          isClearable
                        />
                      </Table.Cell>
                    </Table.Row>
                  </Table.Container>
                )}
              </Layout.Group>
            </Layout.Stack>
            {!isEditable && data?.userId !== '' && isSearchButtonClicked && (
              <Layout.Group alignLayout="center" css={{ marginTop: '20px' }}>
                <Button onClick={() => handleReset()}>Cancel</Button>
                <Button onClick={handleSubmit}>Submit</Button>
              </Layout.Group>
            )}
            {isEditable && data?.userId !== null && data?.userStsCd === 'A' && (
              <Layout.Group alignLayout="center" css={{ marginTop: '20px' }}>
                <Button onClick={() => handleUserremoval()}>Remove</Button>
                <Button onClick={() => setIsEditable(false)}>
                  Change Access
                </Button>
              </Layout.Group>
            )}

            <Layout.Group alignLayout="center">
              {isEditable && (data?.userStsCd === 'D' || data?.userId == null) && (
                <Button
                  css={{ width: '150px', marginTop: '10px' }}
                  onClick={() => setIsEditable(false)}
                >
                  Add Access
                </Button>
              )}
            </Layout.Group>
            {isEditable && data?.userId !== null && (
              <Grid.Col css={{ width: '100%' }}>
                <Box
                  color="$web.semantic.color.surface.container.primary"
                  padding={0}
                  width="100%"
                  height="20px"
                  align="center"
                >
                  <Text
                    asElement="label"
                    color="$web.semantic.color.text.content.primary-alt"
                    css={{ fontSize: '14px', fontWeight: 'bold' }}
                  >
                    UPDATED ON {`${form.getValues('updtTime')}`} BY{' '}
                    {`${
                      form.getValues('updtUser')
                        ? form.getValues('updtUser')
                        : '-'
                    }`}
                  </Text>
                </Box>
                <Divider orientation="horizontal" />
              </Grid.Col>
            )}
          </Card>
        </Grid.Col>
      </Grid>
    </FormProvider>
  );
};

export default RoleAdmin;
